import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { RoleGuard } from '../guards/role-guard.service'

import { CanDeactivateGuard } from '../guards/can-deactivate.guard'

const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./reinsurer-route.container').then((m) => m.ReinsurerRouteContainerComponent),
    data: { contextPath: ['reinsurers'] },
    canActivate: [RoleGuard],
    canDeactivate: [CanDeactivateGuard],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReinsurerRoutingModule {}
